import { setUser } from '@sentry/react';
import { useEffect, useRef } from 'react';
import CryptoJS from 'crypto-js';

import { getEnv } from '@luna/env';

const hashUserId = (id: string): string => {
    return CryptoJS.SHA1(id).toString();
};

/**
 * Global user id is set in sentry to associate a user to
 * the session. This allows us to know how many different users
 * encounter a given issue.
 * */
export const setSentryUserId = (id?: string): void => {
    if (!id) {
        return;
    }
    setUser({ id: hashUserId(id) });
};

export const useSetUserIdInSentry = (id?: string): void => {
    const setUserTriggered = useRef<boolean>(false);
    useEffect(() => {
        const isSentryEnabled = !!getEnv().sentry;
        if (!isSentryEnabled || !id || setUserTriggered.current) {
            return;
        }
        setSentryUserId(id);
        setUserTriggered.current = true;
    }, [id]);
};
